import Chip from "@/components/Chip";
import SimpleTable from "@/components/SimpleTable";
import { Button } from "@/components/ui/button";
import ApplyCertificateButton from "@/src/console/(auth)/certifications/_components/ApplyCertificateButton";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface CertificationTableProps {
  data: {
    id: number;
    company_name: string;
    issued_at: Date | null;
    status: number;
    submitted_at: Date | null;
  }[];
  isLoading: boolean;
}

function CertificationTable({ data, isLoading }: CertificationTableProps) {
  const statusList = [
    "All Status",
    "Applied",
    "Certified",
    "Expired",
    "Not Issued",
  ];
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <SimpleTable
      data={data}
      isLoading={isLoading}
      columns={[
        {
          key: "companyName",
          label: t("company-name"),
          render: ({ company_name }) => company_name,
        },
        {
          width: "160px",
          key: "applicationDate",
          label: t("application-date"),
          render: ({ submitted_at }) =>
            submitted_at
              ? format(submitted_at, t("date-time-format"))
              : "----/--/--, --:--",
        },
        {
          width: "150px",
          key: "process",
          label: t("status"),
          render: ({ status }) => {
            const variant =
              status === 2 ? "success" : status === 3 ? "danger" : "warning";
            return <Chip label={statusList[status]} variant={variant} />;
          },
        },
        {
          width: "250px",
          key: "action",
          label: t("action"),
          render: ({ id, status }) =>
            status === 4 ? (
              <ApplyCertificateButton id={id} />
            ) : (
              <Button
                variant="outline"
                onClick={() => navigate(`/console/certifications/${id}`)}
              >
                {t("check")}
              </Button>
            ),
        },
      ]}
    />
  );
}

export default CertificationTable;
